<template>
  <div>
    <div
      class="card-ui main-app-signin login-card-signin ml-auto mr-auto"
      style="box-shadow: none"
    >
        <h2 style="padding: 10px">Sign up</h2>
        <el-form
          style="margin-top: 26px;"
          :model="registerForm"
          :rules="registerRules"
          ref="registerForm"
          label-width="120px"
          :disabled="bRegisterFormSubmitting"
          v-on:validate="_onFormValidate"
        >
          <!-- firstname -->
          <div class="el-form-element">
            <el-form-item
              prop="firstName"
              label-width="0"
              style="margin-bottom: 20px;width: 100%"
            >
              <el-input
                :placeholder="$t('scenes.auth.register.userForm.firstName')"
                size="large"
                v-model="registerForm.firstName"
                @keyup.enter.native="onClickRegisterButton()"
              >
              </el-input>
            </el-form-item>
          </div>
          <!-- surname -->
          <div class="el-form-element">
            <el-form-item
              prop="lastName"
              label-width="0"
              style="margin-bottom: 20px;width: 100%"
            >
              <el-input
                :placeholder="$t('scenes.auth.register.userForm.lastName')"
                size="large"
                v-model="registerForm.lastName"
                @keyup.enter.native="onClickRegisterButton()"
              >
              </el-input>
            </el-form-item>
          </div>
          <!-- username -->
          <div class="el-form-element">
            <el-form-item
              prop="userId"
              label-width="0"
              style="margin-bottom: 20px;width: 100%"
            >
              <el-input
                :placeholder="$t('scenes.auth.register.userForm.userId')"
                size="large"
                v-model="registerForm.userId"
                @keyup.enter.native="onClickRegisterButton()"
              >
                <i
                  slot="prefix"
                  class="el-input__icon material-icons input-icon"
                  >email</i
                >
              </el-input>
            </el-form-item>
          </div>
          <!-- password -->
          <div class="el-form-element">
            <el-form-item prop="password" label-width="0" style="width: 100%">
              <el-input
                :placeholder="$t('scenes.auth.register.userForm.password')"
                size="large"
                v-model="registerForm.password"
                type="password"
                @keyup.enter.native="onClickRegisterButton()"
              >
                <i
                  slot="prefix"
                  class="el-input__icon material-icons input-icon"
                  >lock_outline</i
                >
              </el-input>
            </el-form-item>
          </div>
          <!-- password confirm -->
          <div class="el-form-element">
            <el-form-item
              prop="passwordConfirmation"
              label-width="0"
              style="width: 100%"
            >
              <el-input
                :placeholder="
                  $t('scenes.auth.register.userForm.passwordConfirmation')
                "
                size="large"
                v-model="registerForm.passwordConfirmation"
                type="password"
                @keyup.enter.native="onClickRegisterButton()"
              >
                <i
                  slot="prefix"
                  class="el-input__icon material-icons input-icon"
                  >lock_outline</i
                >
              </el-input>
            </el-form-item>
            <span style="font-size: 12px; color:#313131">
              By clicking <strong>create account</strong>, you agree to our
              <a
                href="https://memento-yearbooks.com/terms-of-use/"
                target="_blank"
                >terms of use</a
              >
              and
              <a href="https://memento-yearbooks.com/privacy/" target="_blank"
                >privacy policy</a
              >.
            </span>
          </div>
        </el-form>
        <div class="form-element">
          <el-button
            type="primary"
            style="width: 100%; margin-top: 10px"
            @click="onClickRegisterButton"
            :disabled="!showRegisterAccountButton"
            >{{ $t("scenes.auth.register.userForm.createAccount") }}</el-button
          >
          <div style="font-size: 12px; color:#313131" class="mt-3" @click="onClickIHaveAnAccountBtn">
              Already have an account?  <a
              href="#"
          >Sign in!</a
          >
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { BMH_GetPasswordErrors } from "@/util";
import { registerUser } from "../api";
import { httpStatusException } from "../../../api";
import { mapActions, mapGetters } from "vuex";
import { SF_COOKIE_REMEMBER_ME } from "../persistence/constants";
import Cookies from "js-cookie";
import config from "@/config";
export default {
  name: "RegisterForm",
  data() {
    const validatePassword = (rule, value, callback) => {
      callback(BMH_GetPasswordErrors(value));
    };

    const validatePasswordConfirm = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(
          new Error(
            this.$t("scenes.auth.oPasswordValidation.m_strErrorPwdsNotSame")
          )
        );
      } else {
        callback(BMH_GetPasswordErrors(value));
      }
    };
    return {
      formIsValid: false,
      bRegisterFormSubmitting: false,
      registerForm: {
        firstName: null,
        lastName: null,
        userId: null,
        password: null,
        passwordConfirmation: null
      },
      registerRules: {
        firstName: [
          {
            required: true,
            message: this.$t("scenes.auth.register.formErrors.firstName"),
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: this.$t("scenes.auth.register.formErrors.lastName"),
            trigger: "blur"
          }
        ],
        userId: [
          {
            required: true,
            message: this.$t("scenes.auth.register.formErrors.userId.required"),
            trigger: "blur"
          },
          {
            type: "email", // this is enforced at the API too
            message: this.$t("scenes.auth.register.formErrors.userId.valid"),
            trigger: "blur"
          }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: "blur" }
        ],
        passwordConfirmation: [
          {
            required: true,
            validator: validatePasswordConfirm,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["getStorefrontId"]),
    showRegisterAccountButton() {
      let formFieldsArePopulated = false;
      const values = Object.values(this.registerForm);
      for (const value of values) {
        formFieldsArePopulated = value !== null;
      }
      return (
        this.formIsValid &&
        !this.bRegisterFormSubmitting &&
        formFieldsArePopulated === true
      );
    }
  },
  methods: {
    ...mapActions(["login", "me"]),
    onClickCreateAccountBtn() {
      this.$emit("evt-on-click-create-account");
    },
    onClickIHaveAnAccountBtn() {
      this.$emit("evt-on-click-i-have-an-account");
    },
    onClickRegisterButton: async function() {
      this.$refs["registerForm"].validate(async valid => {
        this.formIsValid = valid;
        if (valid) {
          this.bRegisterFormSubmitting = true;
          let bSignupError = false;
          // first, let's try registering the user
          try {
            const oRequest = {
              first_name: this.registerForm.firstName,
              last_name: this.registerForm.lastName,
              username: this.registerForm.userId,
              password: this.registerForm.password,
              signup_context: "storefront",
              storefront_id: this.getStorefrontId
            };
            await registerUser(oRequest);
          } catch (err) {
            // if we failed here, it's most likely because the username is already taken
            // the API will be validating that it's not already being used
            // (both as a username or a contact email for a BM user account)
            console.error(err);
            bSignupError = true;
            let errMessage = "Sorry something went wrong. Please try again";
            if (err instanceof httpStatusException) {
              if (err.message) {
                if (err.message.username || err.message.email) {
                  errMessage = "That email address is already taken";
                }
              }
            }
            this.$message({
              message: errMessage,
              type: "error"
            });
          } finally {
            // if registration was successful, try logging the user in
            // and requesting their profile information
            if (!bSignupError) {
              try {
                await this.login({
                  username: this.registerForm.userId,
                  password: this.registerForm.password
                });
                await this.me();
                // we're all done
                this.authSuccess(this.registerForm.userId);
              } catch (e) {
                // if we fail here, we need to differentiate the error message, since the account
                // was registered, but authentication/fetching the profile failed
                this.$notify.error({
                  title: "Signup error",
                  message:
                    "Your account was created but we failed to sign you in. Please try signing in manually.",
                  duration: 0
                });
              }
            }
            this.bRegisterFormSubmitting = false;
          }
        }
      });
    },
    authSuccess(inEmailAddress) {
      // registration was successful and the user is signed in
      // emit an event so the parent knows to redirect the
      // user away from the login page
      this.$message({
        message: `You are now signed in as ${inEmailAddress}`,
        type: "success"
      });
      Cookies.set(SF_COOKIE_REMEMBER_ME, true, config.get("COOKIE_SETTINGS"));
      this.$emit("evt-auth-success");
    },
    // Whenever the validation event of the form is emitted, update a local flag.
    // This is primarily just to help with enabling/disabling the register button (for UX).
    _onFormValidate(formItemName, bIsValid) {
      // Note: Updates in the password field do not automatically trigger validation of password confirm.
      // In the scenario that the user has entered a valid password/passwordConfirm, but GOES BACK
      // and edits their password - the passwordConfirmation field remains valid.
      // Here, we trigger a manual validation, since we know the two values won't match.
      if (
        formItemName === "password" &&
        bIsValid &&
        this.registerForm.passwordConfirmation
      ) {
        this.$refs["registerForm"].validateField("passwordConfirmation");
      } else {
        this.formIsValid = bIsValid;
      }
    }
  }
};
</script>

<style scoped>
.el-form-item.is-error {
  margin-bottom: 30px;
}
</style>
